interface EpisodeListProps {
  episodes: string[];
  active: number;
  onSelect: (index: number) => void;
}

export default function EpisodeList({ episodes, active, onSelect }: EpisodeListProps) {
  return (
    <div className="rounded-lg bg-background-100 border border-background-300/50 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-primary-500" />
          剧集列表
        </h2>
        <span className="text-xs text-foreground-500">共 {episodes.length} 集</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2">
        {episodes.map((ep, i) => (
          <button
            key={ep}
            type="button"
            onClick={() => onSelect(i)}
            className={`px-3 py-2.5 rounded-md text-xs md:text-sm truncate transition-colors cursor-pointer ${
              i === active
                ? "bg-primary-500 text-background-50 font-medium"
                : "bg-background-200/70 text-foreground-700 hover:bg-background-300 hover:text-foreground-950"
            }`}
            title={ep}
          >
            {ep}
          </button>
        ))}
      </div>
    </div>
  );
}